<template>
    <div class="yearSwiper borderTop borderLRB">
        <div class="swiper-container" ref="yearSwiper">
            <div class="swiper-wrapper">
                <div class="swiper-wrapper-box">
                    <div :class="i==yearIndex?'swiper-slide-active':''" class="swiper-slide color999" v-for="(item, i) in yearList" :key="i" @click="yearClick(item,i)">
                        {{item}}
                    </div>
                </div>
            </div>
<!--            <div class="swiper-button-next" @click="nextClick"></div>-->
<!--            <div class="swiper-button-prev" @click="preClick"></div>-->
        </div>

    </div>
</template>

<script>
import Swiper from "swiper";
import { postDate } from '@/api/company'

export default {
    name: "yearSwiper",
    data(){
        return{
            yearList:['全部'],
            option:{
                slidesPerView: 3,
                observer:true,
                observeParents:true,
            },
            yearIndex:0,
        }
    },
    mounted() {
        this.postDate()
        // this.$nextTick(()=>{
        //     setTimeout(function (){
        //         new Swiper('.swiper-container', {
        //             slidesPerView: 2,
        //             spaceBetween: 40,
        //             navigation: {
        //                 nextEl: '.swiper-button-next',
        //                 prevEl: '.swiper-button-prev',
        //             },
        //         });
        //     },500)
        // })
    },
    methods:{
        yearClick(item,i){
            this.$emit('clickYearSwiper', item)
            // this.yearIndex=i;
            // this.$emit('yearChange',item);
        },
        nextClick(){
            this.$refs.yearSwiper.slideNext();
        },
        preClick(){
            this.$refs.yearSwiper.slidePrev();
        },
        postDate() {
            postDate().then(res => {
                for(let i = 0; i < res.data.list.length; i++) {
                    this.yearList.push(res.data.list[i].year)
                }
            })
        }
    },
}
</script>

<style scoped lang="scss">
@import '@/assets/css/auctionCompany.scss';
.yearSwiper{
    position: relative;
    .swiper-container{

        overflow-x: auto;
        overflow-y: hidden;
        width: 600px;
        margin: 0 auto;
        .swiper-wrapper{
            padding: 18px 0;
            height: 58px;
            white-space: nowrap;
        }
        .swiper-wrapper-box{}
        .swiper-slide{width:54px!important;height:20px;display:inline-block;cursor:pointer;font: normal 20px/19px Verdana;margin-right: 28px;}
        .swiper-slide-active,.swiper-slide:hover{color: #000;}
        .swiper-button-prev, .swiper-button-next{width:10px;height:19px;background-image: url("../../../../assets/imgs/old/yearBg.png");
            cursor:pointer;overflow: hidden;background-repeat: no-repeat;display: inline-block;
            position: absolute; margin-top: -39px; }
        .swiper-button-prev:after,.swiper-button-next:after{content:'';}
        .swiper-button-next{background-position: left -136px;margin-right: 15px;
            margin-left: 7px;left: 20px}
        .swiper-button-prev{background-image: url("../../../../assets/imgs/old/yearBg.png");background-position: left -170px;margin-left: 19px;
            margin-right: 7px;right: 20px}
    }
}

</style>